var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import { InfoOutlined } from '@mui/icons-material';
import MoreVert from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
var menuOptions = [
    { label: 'Edit', value: 'EDIT', tooltip: '' },
    { label: 'Reset Password', value: 'RESET_PASSWORD', tooltip: '' },
    {
        label: 'Delete',
        value: 'DELETE',
        tooltip: 'When deleted, user will not have access to Unisetu. They will not be able to login in Unisetu.'
    },
    { label: 'Activate', value: 'ACTIVATE', tooltip: '' },
    {
        label: 'Disable',
        value: 'DISABLE',
        tooltip: 'When disabled, user will still have access to Unisetu. They will be not able to create new students/applications'
    },
    { label: 'View Student Funnel', value: 'VIEW_STUDENT_FUNNEL', tooltip: '' }
];
function ActionMenu(props) {
    var _a = __read(React.useState(null), 2), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var selectOption = function (status) {
        var _a;
        handleClose();
        (_a = props === null || props === void 0 ? void 0 : props.onMenuClick) === null || _a === void 0 ? void 0 : _a.call(props, status);
    };
    var options = menuOptions.filter(function (op) { var _a; return !((_a = props === null || props === void 0 ? void 0 : props.hideOptions) !== null && _a !== void 0 ? _a : []).includes(op === null || op === void 0 ? void 0 : op.value); });
    return (React.createElement("div", null,
        React.createElement(IconButton, { onClick: handleClick },
            React.createElement(MoreVert, null)),
        React.createElement(Menu, { transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorEl: anchorEl, open: open, onClose: handleClose }, options.map(function (option) { return (React.createElement(MenuItem, { key: option.value, onClick: function () {
                selectOption(option.value);
            }, className: "lfc-flx lfc-justify-between" },
            React.createElement(GBTypography, { variant: "cta5" }, option.label),
            (option === null || option === void 0 ? void 0 : option.tooltip) && (React.createElement(Tooltip, { title: option === null || option === void 0 ? void 0 : option.tooltip, arrow: true },
                React.createElement(InfoOutlined, { className: "lfc-text-xs" }))))); }))));
}
export default ActionMenu;
//# sourceMappingURL=ActionMenu.js.map